.contentBand {
    width: 100%;
    background: #FFFFFF;
}

.inner {
    width: min(100% - 32px, 960px);
    margin: 0 auto;
    padding: 64px 0;
}

.copy {
    max-width: 780px;
}

.copy p {
    color: #263238;
    line-height: 1.75;
}

.topicGrid {
    padding-top: 16px;
    border-top: 1px solid rgba(38, 50, 56, 0.14);
}

.topicGrid h2 {
    color: #0E7F83;
    line-height: 1.25;
}

.ctaWrap {
    width: min(100%, 260px);
}

.formWrap {
    width: 100%;
    padding: 48px 0;
}

.orthoInfoIntroBand {
    width: 100%;
    background: #F2F2F2;
}

.orthoInfoIntroInner {
    box-sizing: border-box;
    width: min(100% - 32px, 1100px);
    margin: 0 auto;
    padding: 80px 0;
    text-align: center;
}

.orthoInfoHeading {
    margin: 0 0 24px;
    color: #35ADB0;
    font-size: 42px;
    font-weight: 700;
    line-height: 1.1;
}

.orthoInfoCopy {
    max-width: 980px;
    margin: 0 auto 18px;
    color: #000000;
    font-size: 18px;
    line-height: 1.55;
}

.orthoInfoCopy:last-child {
    margin-bottom: 0;
}

.orthoInfoCardsBand {
    width: 100%;
    background: #DCEFF0;
}

.orthoInfoCardsGrid {
    box-sizing: border-box;
    width: min(100% - 32px, 1100px);
    margin: 0 auto;
    padding: 80px 0;
    gap: 30px;
}

.orthoInfoCard {
    min-height: 300px;
}

.inlineLink {
    color: #35ADB0;
    text-decoration: none;
}

.invisalignIntroBand {
    width: 100%;
    background: #FFFFFF;
}

.invisalignBlueBand {
    width: 100%;
    background: #E7F4F5;
}

.invisalignNarrow {
    width: min(100% - 32px, 1000px);
    margin: 0 auto;
    padding: 64px 0;
    text-align: center;
}

.invisalignNarrow p {
    color: #263238;
    line-height: 1.75;
    margin: 0 0 22px;
}

.invisalignSectionHeading {
    color: #35ADB0;
    font-size: 35px;
    line-height: 1.1;
    margin: 0 0 24px;
}

.invisalignFeatureImage {
    display: block;
    height: auto;
    margin: 0 auto 36px;
    max-width: 100%;
    width: 100%;
}

.invisalignTwoColumn {
    align-items: center;
    width: min(100% - 32px, 1100px);
    margin: 0 auto;
    padding: 64px 0;
}

.invisalignColumnCopy {
    text-align: left;
}

.invisalignColumnCopy p {
    color: #263238;
    line-height: 1.75;
    margin: 0 0 22px;
}

.invisalignTwoColumn .invisalignFeatureImage {
    margin-bottom: 0;
}

.miamiInvisalignArticle {
    width: 100%;
    padding: 20px 40px 28px;
    background: #FFFFFF;
}

.miamiInvisalignHeading {
    color: #35ADB0;
    font-size: 35px;
    line-height: 1.1;
    margin: 0 0 24px;
}

.miamiInvisalignCopy {
    color: #000000;
    font-size: 18px;
    line-height: 1.55;
    margin: 0 0 25px;
}

.miamiInvisalignImage {
    display: block;
    height: auto;
    margin: 0 0 36px;
    width: 100%;
}

.miamiOrthodonticsHero {
    box-sizing: border-box;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    width: 100%;
    height: calc(100dvh - 85px);
    padding: 0 20px 115px;
    background: #1D1E21;
}

.miamiOrthodonticsHeroTitle {
    color: #FFFFFF;
    box-sizing: border-box;
    width: max-content;
    max-width: min(980px, calc(100% - 80px));
    padding: 0 25px;
    background: #FFA489;
    font-size: 90px;
    line-height: 1.1;
    text-align: center;
}

.miamiOrthodonticsArticle {
    width: min(100% - 40px, 1020px);
    margin: 0 auto;
    padding: 26px 0 0;
    background: #FFFFFF;
    box-shadow: 0 0 0 100vmax #FFFFFF;
    clip-path: inset(0 -100vmax);
}

.miamiOrthodonticsContactGrid {
    display: grid;
    grid-template-columns: minmax(0, 430px) minmax(0, 490px);
    justify-content: space-between;
    gap: 40px;
    margin: 64px 0 72px;
}

.miamiOrthodonticsContact {
    padding-top: 0;
}

.miamiOrthodonticsMap {
    width: 490px;
    max-width: 100%;
    height: 450px;
    border: 0;
}

.miamiOrthodonticsSection {
    margin: 0 0 48px;
}

.orthoCareArticle {
    width: min(100% - 40px, 1020px);
    margin: 0 auto;
    padding: 64px 0 40px;
    background: #FFFFFF;
}

.orthoCareMainHeading,
.orthoCareHeading {
    color: #3CAEB0;
    font-weight: 700;
    line-height: 1.1;
    margin: 0 0 24px;
}

.orthoCareMainHeading {
    font-size: 42px;
}

.orthoCareHeading {
    clear: both;
    font-size: 32px;
}

.orthoCareSection {
    margin: 0 0 38px;
}

.orthoCareCopy,
.orthoCareList {
    color: #000000;
    font-size: 18px;
    line-height: 1.55;
}

.orthoCareCopy {
    margin: 0 0 22px;
}

.orthoCareList {
    padding-left: 28px;
    margin: 0 0 22px;
}

.orthoCareList li {
    margin: 0 0 14px;
}

.orthoCareImage {
    float: left;
    width: min(410px, 48%);
    height: auto;
    margin: 0 32px 24px 0;
}

.emergencyAccordion {
    width: 100%;
    margin-top: 34px;
}

.emergencyAccordionItem {
    border-top: 1px solid rgba(60, 174, 176, 0.28);
}

.emergencyAccordionItem:last-child {
    border-bottom: 1px solid rgba(60, 174, 176, 0.28);
}

.emergencyAccordionHeader {
    margin: 0;
}

.emergencyAccordionTrigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border: 0;
    padding: 20px 0;
    background: transparent;
    color: #3CAEB0;
    cursor: pointer;
    font: inherit;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.2;
    text-align: left;
}

.emergencyAccordionIcon {
    flex: 0 0 auto;
    margin-left: 24px;
    color: #3CAEB0;
    font-size: 28px;
    line-height: 1;
}

.emergencyAccordionTrigger[data-state="open"] .emergencyAccordionIcon {
    transform: rotate(45deg);
}

.emergencyAccordionContent {
    overflow: hidden;
}

.emergencyAccordionContentInner {
    padding: 0 0 18px;
}

.emergencyAccordionContentInner .orthoCareCopy:last-child {
    margin-bottom: 0;
}

.miamiOrthodonticsHeading {
    color: #3CAEB0;
    font-size: 35px;
    font-weight: 400;
    line-height: 1.1;
    margin: 0 0 25px;
}

.miamiOrthodonticsCopy {
    color: #000000;
    font-size: 18px;
    line-height: 1.55;
    margin: 0 0 25px;
}

.invisalignContentSection {
    margin: 0 0 56px;
}

.invisalignContentSection:last-child {
    margin-bottom: 0;
}

.invisalignInfoGrid {
    margin-top: 28px;
    text-align: left;
}

.invisalignInfoItem {
    background: #FFFFFF;
    box-sizing: border-box;
    padding: 28px;
}

.invisalignItemHeading {
    color: #35ADB0;
    font-size: 24px;
    line-height: 1.15;
    margin: 0 0 14px;
}

.invisalignInfoItem p {
    margin-bottom: 0;
}

.invisalignFlBand {
    width: 100%;
    background: #FFFFFF;
}

.invisalignFlInner {
    width: min(100% - 40px, 1262px);
    margin: 0 auto;
    padding: 64px 0 0;
}

.invisalignFlInner p,
.invisalignFlSummaryList {
    color: #000000;
    font-size: 18px;
    line-height: 1.55;
}

.invisalignFlInner p {
    margin: 0 0 25px;
}

.invisalignFlPageTitle {
    color: #3CAEB0;
    font-size: 70px;
    font-weight: 700;
    line-height: 1.1;
    margin: 0 0 25px;
}

.invisalignFlSectionHeading {
    color: #3CAEB0;
    font-size: 50px;
    font-weight: 700;
    line-height: 1.1;
    margin: 0 0 25px;
}

.invisalignFlItemHeading {
    color: #3CAEB0;
    font-size: 35px;
    font-weight: 700;
    line-height: 1.1;
    margin: 0 0 25px;
}

.invisalignFlFeatureImage {
    display: block;
    height: auto;
    margin: 0 0 64px;
    max-width: 100%;
    width: 100%;
}

.invisalignFlContentSection {
    margin: 0 0 56px;
}

.invisalignFlContentSection:last-child {
    margin-bottom: 0;
}

.invisalignFlSummaryList {
    margin: 0 0 25px 22px;
    padding: 0;
}

.invisalignFlSummaryList li {
    margin: 0 0 6px;
}

.invisalignFlItem {
    margin: 0 0 25px;
}

.invisalignFlItem:last-child {
    margin-bottom: 0;
}

@media only screen and (max-width: 1140px) {
    .invisalignFlPageTitle {
        font-size: 62px;
    }
}

@media only screen and (max-width: 768px) {
    .miamiInvisalignArticle {
        padding-right: 20px;
        padding-left: 20px;
    }

    .miamiInvisalignHeading {
        font-size: 25px;
    }

    .miamiOrthodonticsHero {
        padding: 0 15px 84px;
    }

    .miamiOrthodonticsHeroTitle {
        max-width: 100%;
        font-size: 35px;
    }

    .miamiOrthodonticsArticle {
        width: calc(100% - 40px);
        padding-top: 26px;
    }

    .miamiOrthodonticsContactGrid {
        grid-template-columns: 1fr;
        gap: 36px;
        margin: 64px 0 72px;
    }

    .miamiOrthodonticsMap {
        width: 100%;
        height: 450px;
    }

    .miamiOrthodonticsHeading {
        font-size: 35px;
    }

    .orthoCareArticle {
        width: calc(100% - 40px);
        padding: 48px 0 28px;
    }

    .orthoCareMainHeading {
        font-size: 35px;
    }

    .orthoCareHeading {
        font-size: 28px;
    }

    .orthoCareImage {
        float: none;
        width: 100%;
        margin: 0 0 26px;
    }

    .emergencyAccordionTrigger {
        font-size: 20px;
    }

    .orthoInfoIntroInner {
        padding: 56px 0;
    }

    .orthoInfoHeading {
        font-size: 34px;
    }

    .orthoInfoCardsGrid {
        padding: 56px 0;
        gap: 22px;
    }

    .orthoInfoCard {
        min-height: 240px;
    }

    .invisalignFlPageTitle {
        font-size: 40px;
    }

    .invisalignFlSectionHeading {
        font-size: 32px;
    }

    .invisalignFlItemHeading {
        font-size: 25px;
    }
}

@media only screen and (max-width: 480px) {
    .miamiOrthodonticsHero {
        padding-bottom: 104px;
    }
}

.lifeBand {
    width: 100%;
    background: #FFFFFF;
}

.lifeIntroBand {
    width: 100%;
    background: #F3F3F3;
}

.lifeIntroInner {
    width: min(100% - 40px, 752px);
    margin: 0 auto;
    padding: 64px 0 20px;
    text-align: center;
}

.lifeContentInner {
    width: min(100% - 40px, 798px);
    margin: 0 auto;
    padding: 64px 0 0;
}

.lifeIntroInner p,
.lifeContentInner p,
.lifeList {
    color: #000000;
    font-size: 18px;
    line-height: 1.55;
}

.lifeIntroInner p,
.lifeContentInner p {
    margin: 0 0 25px;
}

.lifeCenteredCopy {
    text-align: center;
}

.lifeSectionHeading {
    color: #3CAEB0;
    font-size: 50px;
    line-height: 1.1;
    margin: 0 0 25px;
    text-align: center;
}

.lifeSubheading {
    color: #3CAEB0;
    font-size: 35px;
    line-height: 1.1;
    margin: 0 0 25px;
}

.lifeMinorHeading {
    color: #3CAEB0;
    font-size: 24px;
    line-height: 1.1;
    margin: 0 0 25px;
}

.lifeSection {
    margin: 0 0 25px;
}

.lifeFeatureImage {
    display: block;
    height: auto;
    margin: 40px auto;
    max-width: 100%;
    width: 100%;
}

.lifeList {
    margin: 0 0 25px 22px;
    padding: 0;
}

.lifeList li {
    margin: 0 0 6px;
}

.lifeFoodGrid {
    align-items: start;
    margin: 0 0 25px;
}

.miamiBracesBand {
    width: 100%;
    background: #FFFFFF;
}

.miamiBracesInner {
    width: min(100%, 1100px);
    margin: 0 auto;
    padding: 20px 0;
}

.miamiBracesTwoColumn {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.miamiBracesTwoColumn + .miamiBracesTwoColumn {
    margin-top: 25px;
}

.miamiBracesSmallColumn,
.miamiBracesFullColumn {
    padding: 20px;
}

.miamiFamilyFullColumn {
    padding: 20px;
}

.miamiFamilyCareColumn {
    margin-top: 98px;
}

.miamiFamilyDoctorGrid {
    width: 100%;
}

.miamiFamilyHeroHeadingWrapper {
    padding-bottom: 24px;
}

.miamiFamilyHeroHeading {
    max-width: min(920px, calc(100% - 160px));
}

.miamiBracesImage {
    display: block;
    height: auto;
    max-width: 100%;
    width: 100%;
}

.miamiFamilyDoctorImage {
    display: block;
    height: auto;
    max-width: 100%;
    width: 100%;
}

.miamiBracesSectionHeading {
    color: #3CAEB0;
    font-size: 50px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 1.1;
    margin: 0 0 25px;
}

.miamiBracesSubheading {
    color: #3CAEB0;
    font-size: 35px;
    letter-spacing: 0;
    line-height: 1.1;
    margin: 0 0 25px;
}

.miamiFamilyMinorHeading {
    color: #3CAEB0;
    font-size: 24px;
    letter-spacing: 0;
    line-height: 1.1;
    margin: 0 0 25px;
}

.miamiBracesCopy {
    color: #000000;
    font-size: 18px;
    line-height: 1.55;
    margin: 0 0 25px;
}

.miamiBracesCopy:last-child {
    margin-bottom: 0;
}

@media only screen and (max-width: 768px) {
    .lifeIntroInner {
        padding-top: 40px;
    }

    .lifeContentInner {
        padding-top: 40px;
    }

    .lifeSectionHeading {
        font-size: 32px;
    }

    .lifeSubheading {
        font-size: 25px;
    }

    .lifeMinorHeading {
        font-size: 20px;
    }

    .miamiBracesInner {
        width: 100%;
    }

    .miamiBracesTwoColumn {
        grid-template-columns: 1fr;
    }

    .miamiBracesSmallColumn {
        width: 100%;
        max-width: 400px;
        margin: 0 auto;
    }

    .miamiBracesSectionHeading {
        font-size: 32px;
    }

    .miamiBracesSubheading {
        font-size: 25px;
    }

    .miamiFamilyMinorHeading {
        font-size: 20px;
    }

    .miamiFamilyCareColumn {
        padding-right: 40px;
        padding-left: 40px;
    }

    .miamiFamilyHeroHeadingWrapper {
        padding-bottom: 79px;
    }

    .miamiFamilyHeroHeading {
        max-width: calc(100% - 40px);
    }
}

@media only screen and (min-width: 769px) {
    .miamiFamilyFullColumn {
        padding-right: 40px;
        padding-left: 40px;
    }

    .miamiFamilyCareColumn {
        margin-top: 98px;
        padding-right: 60px;
        padding-left: 60px;
    }

    .miamiFamilyDoctorGrid > :first-child {
        padding-right: 20px;
        padding-left: 40px;
    }

    .miamiFamilyDoctorGrid > :last-child {
        padding-right: 40px;
        padding-left: 20px;
    }
}

@media only screen and (min-width: 981px) {
    .miamiFamilyHeroHeading {
        max-width: min(700px, calc(100% - 160px));
        font-size: 60px;
        line-height: 1.05;
    }
}

.blogBanner {
    width: 100%;
    background: #F9F9F9;
    padding: 56px 0;
}

.blogBannerInner {
    width: min(100% - 32px, 1100px);
    margin: 0 auto;
    text-align: center;
}

.blogTitle {
    color: #35ADB0;
    font-size: 52px;
    line-height: 1.1;
    margin: 0;
}

.blogInner {
    width: min(100% - 32px, 1100px);
    margin: 0 auto;
    padding: 56px 0 72px;
}

.blogGrid {
    align-items: stretch;
}

.careersBand {
    width: 100%;
    background: #F3F3F3;
}

.careersInner {
    width: min(100% - 32px, 1000px);
    margin: 0 auto;
    padding: 64px 0;
    text-align: center;
}

.careersHeading {
    color: #35ADB0;
    font-size: 42px;
    line-height: 1.15;
    margin: 0 0 20px;
}

.careersText {
    color: #263238;
    margin: 0 0 18px;
    line-height: 1.7;
}

.careersEmailCta {
    display: inline-block;
    margin-top: 8px;
    padding: 0 38px;
    background: #FFA489;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 700;
    line-height: 50px;
    letter-spacing: 2px;
    text-decoration: none;
    text-transform: uppercase;
}

.careersEmailCta:hover {
    background: #35ADB0;
    color: #FFFFFF;
}

.contactBand {
    width: 100%;
    background: #FFFFFF;
}

.contactTopBand {
    width: 100%;
    background: #F3F3F3;
}

.contactTopInner,
.contactInner {
    width: min(100%, 1110px);
    margin: 0 auto;
}

.contactTopInner {
    padding: 136px 0 88px;
}

.contactInner {
    padding: 0 0 88px;
}

.contactTopGrid,
.contactMapLocationGrid {
    display: grid;
    gap: 40px;
    padding: 0 25px;
}

.contactTopGrid {
    grid-template-columns: minmax(0, 730px) minmax(0, 290px);
    align-items: start;
}

.contactMapLocationGrid {
    grid-template-columns: minmax(0, 290px) minmax(0, 730px);
    grid-template-areas: "location map";
    margin-top: 226px;
}

.contactHeading {
    margin: 0 0 25px;
    color: #3CAEB0;
    font-size: 35px;
    line-height: 1.1;
}

.contactText {
    margin: 0 0 25px;
    color: #000000;
    font-size: 18px;
    line-height: 1.55;
}

.inlineTextLink {
    color: #35ADB0;
    text-decoration: underline;
    text-underline-offset: 2px;
}

.inlineTextLink:hover {
    color: #02A4C7;
}

.plainTextLink {
    color: #000000;
    text-decoration: none;
}

.plainTextLink:hover {
    color: #35ADB0;
}

.contactMapWrap {
    grid-area: map;
    width: 100%;
    height: 350px;
}

.contactLocation {
    grid-area: location;
    padding-top: 76px;
}

.contactMap {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
}

.contactLine {
    display: block;
}

.contactHoursBlock {
    padding-top: 0;
}

.contactHoursTitle {
    margin: 0 0 16px;
    color: #3CAEB0;
    font-size: 24px;
    line-height: 1.25;
}

.contactHoursList {
    color: #000000;
    text-align: left;
}

.covidBand {
    width: 100%;
    background: #FFFFFF;
}

.covidInner {
    width: min(100% - 40px, 1110px);
    margin: 0 auto;
    padding: 86px 0 96px;
}

.covidHeading {
    margin: 0 0 25px;
    color: #3CAEB0;
    font-size: 50px;
    line-height: 1.1;
}

.covidText {
    margin: 0 0 25px;
    color: #000000;
    font-size: 18px;
    line-height: 1.55;
}

.covidInstructionGrid {
    max-width: 760px;
    margin-top: 34px;
}

.covidInstructionCard {
    min-width: 0;
}

.covidCardHeading {
    margin: 0 0 16px;
    color: #3CAEB0;
    font-size: 25px;
    line-height: 1.1;
}

.covidCtaWrap {
    width: fit-content;
    min-width: 184px;
    margin-top: 12px;
}

.faqsBand {
    width: 100%;
    background: #FFFFFF;
}

.faqsInner {
    box-sizing: border-box;
    width: min(100%, 750px);
    margin: 0 auto;
    padding: 20px 20px 72px;
}

.faqsHeading {
    margin: 0 0 25px;
    color: #3CAEB0;
    font-size: clamp(32px, 8vw, 50px);
    font-weight: 700;
    line-height: 1.1;
    overflow-wrap: normal;
    word-break: normal;
}

.faqsSubheading {
    margin: 0 0 25px;
    color: #3CAEB0;
    font-size: 35px;
    font-weight: 700;
    line-height: 1.1;
}

.faqsList {
    width: 100%;
}

.faqItem {
    border-bottom: 1px solid #E5E5E5;
}

.faqHeader {
    margin: 0;
}

.faqQuestion {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    width: 100%;
    min-height: 79px;
    padding: 20px 25px;
    border: 0;
    background: #FFFFFF;
    color: #3CAEB0;
    font-family: inherit;
    font-size: 26px;
    font-weight: 400;
    line-height: normal;
    text-align: left;
    cursor: pointer;
}

.faqIcon {
    flex: 0 0 auto;
    color: #3CAEB0;
    font-size: 26px;
    line-height: 1;
    transition: transform 0.2s ease;
}

.faqQuestion[data-state="open"] .faqIcon {
    transform: rotate(45deg);
}

.faqAnswer {
    overflow: hidden;
}

.faqAnswer[data-state="open"] {
    animation: faqSlideDown 0.2s ease-out;
}

.faqAnswer[data-state="closed"] {
    display: none;
}

.faqAnswerInner {
    padding: 0 25px 20px;
}

.faqAnswerText {
    margin: 0 0 25px;
    color: #000000;
    font-size: 18px;
    line-height: 1.55;
}

.faqAnswerText:last-child {
    margin-bottom: 0;
}

@keyframes faqSlideDown {
    from {
        height: 0;
    }

    to {
        height: var(--radix-accordion-content-height);
    }
}

@keyframes faqSlideUp {
    from {
        height: var(--radix-accordion-content-height);
    }

    to {
        height: 0;
    }
}

.simplePageBand {
    width: 100%;
    background: #FFFFFF;
}

.simplePageInner {
    width: min(100% - 32px, 1000px);
    margin: 0 auto;
    padding: 64px 0;
}

.simplePageTitle {
    color: #35ADB0;
    font-size: 34px;
    line-height: 1.15;
    margin: 0 0 24px;
}

.termsCopy {
    max-width: 780px;
}

.termsCopy p {
    color: #263238;
    line-height: 1.7;
    margin: 0 0 16px;
}

.termsCopy a {
    color: #35ADB0;
    text-decoration: underline;
}

.thankYouIntroBand {
    width: 100%;
    background: #F3F3F3;
}

.thankYouInner {
    width: min(100% - 32px, 980px);
    margin: 0 auto;
    padding: 56px 0;
    text-align: center;
}

.thankYouIntroHeading {
    color: #35ADB0;
    font-size: 34px;
    line-height: 1.15;
    margin: 0 0 18px;
}

.thankYouIntroCopy {
    color: #263238;
    line-height: 1.75;
    margin: 0 auto;
    max-width: 760px;
}

.thankYouDoctorBand {
    width: 100%;
    background: #FFFFFF;
}

.thankYouDoctorInner {
    width: min(100% - 32px, 1100px);
    margin: 0 auto;
    padding: 56px 0 72px;
}

.thankYouDoctorGrid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 32px;
    align-items: start;
    margin-bottom: 48px;
}

.thankYouDoctorImage {
    display: block;
    width: min(100%, 510px);
    aspect-ratio: 1 / 1;
    object-fit: cover;
}

.thankYouCopyBlock {
    color: #263238;
}

.thankYouCopyBlock p,
.thankYouAffiliations li {
    line-height: 1.65;
}

.thankYouCopyBlock p {
    margin: 0 0 18px;
}

.thankYouSectionHeading {
    color: #35ADB0;
    font-size: 34px;
    line-height: 1.1;
    margin: 0 0 22px;
}

.thankYouSubheading {
    color: #35ADB0;
    font-size: 24px;
    line-height: 1.15;
    margin: 0 0 18px;
}

.thankYouDetailGrid {
    margin-bottom: 48px;
}

.thankYouFamilyImage {
    display: block;
    width: 100%;
    height: auto;
    margin: 0 0 48px;
}

.thankYouAffiliations {
    margin: 0;
    padding-left: 22px;
}

.thankYouCtaBand {
    width: 100%;
    background: #E7F4F5;
    padding: 48px 16px;
}

.thankYouCtaGrid {
    width: min(100%, 1060px);
    margin: 0 auto;
    justify-content: space-between;
    align-content: stretch;
    align-items: stretch;
}

.thankYouCtaItem {
    width: 100%;
    min-width: 0;
    flex: 0 1 100%;
    margin-bottom: 25px;
}

.thankYouCtaItem:last-child {
    margin-bottom: 0;
}

.testimonialsIntroBand {
    width: 100%;
    background: #F3F3F3;
}

.testimonialsBand {
    width: 100%;
    background: #FFFFFF;
}

.testimonialsInner {
    width: min(100% - 32px, 1000px);
    margin: 0 auto;
    padding: 56px 0;
}

.testimonialsTitle {
    color: #35ADB0;
    font-size: 34px;
    line-height: 1.15;
    margin: 0 0 18px;
    text-align: center;
}

.testimonialsIntro {
    color: #263238;
    line-height: 1.75;
    margin: 0 auto;
    max-width: 760px;
    text-align: center;
}

.testimonialGrid {
    align-items: start;
}

.testimonialBlock {
    border-left: 4px solid #35ADB0;
    box-sizing: border-box;
    color: #263238;
    line-height: 1.75;
    margin: 0;
    padding: 0 0 0 24px;
}

.testimonialBlock p {
    margin: 0 0 18px;
}

.testimonialBlockWide {
    width: 100%;
}

.testimonialAuthor {
    color: #35ADB0;
    font-weight: 700;
}

.testimonialImage {
    display: block;
    height: auto;
    margin: 56px 0;
    width: 100%;
}

.articleBand {
    width: 100%;
    background: #FFFFFF;
}


.articleInner {
    width: min(100% - 32px, 1000px);
    margin: 0 auto;
    padding: 48px 0 72px;
}


.featuredImage {
    display: block;
    width: 100%;
    height: auto;
    margin-bottom: 32px;
}

.inlinePostImage {
    display: block;
    height: auto;
    margin: 28px auto;
    max-width: 100%;
    width: auto;
}

.orthodontistIntroGrid {
    align-items: start;
    margin: 32px 0 48px;
}

.orthodontistDoctorPhoto {
    display: block;
    height: auto;
    max-width: 100%;
    width: 100%;
}

.postTitle {
    color: #35ADB0;
    font-size: 44px;
    line-height: 1.08;
    margin: 0 0 8px;
}

.postDate {
    color: #6D7378;
    font-size: 16px;
    line-height: 1.4;
    margin: 0 0 24px;
}

.entryContent {
    max-width: 1000px;
}

.byline {
    color: #222222;
    font-size: 18px;
    line-height: 1.4;
    margin: 0 0 20px;
}

.entryContent p {
    color: #263238;
    line-height: 1.75;
    margin: 0 0 22px;
}

.entryContent a {
    color: #35ADB0;
    text-decoration: underline;
}

.entryContent ul {
    color: #263238;
    line-height: 1.75;
    margin: 0 0 22px;
    padding-left: 24px;
}
















.relatedPosts {
    margin-top: 56px;
}

.relatedTitle {
    color: #35ADB0;
    font-size: 28px;
    line-height: 1.2;
    margin: 0 0 24px;
}

.relatedCard {
    color: inherit;
    display: block;
    width: 100%;
    text-decoration: none;
}

.relatedImage {
    display: block;
    width: 100%;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    margin-bottom: 16px;
}

.relatedImageWide {
    display: block;
    width: 100%;
    height: auto;
    margin-bottom: 16px;
}

.relatedContent {
    width: 100%;
}

.relatedPostTitle {
    color: #35ADB0;
    font-size: 22px;
    line-height: 1.25;
    margin: 0;
}

.postLink {
    color: inherit;
    text-decoration: none;
}

.postCard {
    height: 100%;
    min-height: 440px;
    padding: 0 25px 24px;
    text-align: center;
    cursor: pointer;
}

.postImage {
    width: 100%;
    height: 300px;
    min-height: 300px;
    object-fit: cover;
    object-position: center;
}

.lastmod {
    display: block;
    color: #222325;
    margin: 15px 0 10px;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0;
}

.postCardTitle {
    color: #3CAEB0;
    margin: 0;
    font-size: 25px;
    line-height: 20px;
}

.postLink:hover .postCardTitle {
    color: #02A4C7;
}

@media (max-width: 767px) {
    .contactTopInner {
        width: 100%;
        padding: 88px 0 64px;
    }

    .contactInner {
        width: 100%;
        padding: 0 0 64px;
    }

    .contactTopGrid,
    .contactMapLocationGrid {
        grid-template-columns: 1fr;
        gap: 0;
        width: 100%;
        padding: 0 20px;
    }

    .contactTopGrid {
        grid-template-areas:
            "copy"
            "hours";
    }

    .contactCopy {
        grid-area: copy;
    }

    .contactHoursBlock {
        grid-area: hours;
        margin-top: 67px;
        padding: 0 15px;
        justify-self: center;
        text-align: left;
    }

    .contactHoursList {
        text-align: left;
    }

    .contactMapLocationGrid {
        grid-template-areas:
            "map"
            "location";
        margin-top: 151px;
    }

    .contactLocation {
        margin-top: 40px;
        padding: 0 15px;
    }

    .contactMapWrap {
        height: auto;
        aspect-ratio: 4 / 3;
    }

    .contactHeading {
        font-size: 25px;
        line-height: 1.1;
    }

    .covidInner {
        width: min(100% - 40px, 720px);
        padding: 70px 0 78px;
    }

    .covidHeading {
        font-size: 32px;
    }

    .covidInstructionGrid {
        max-width: 100%;
    }
}

@media (min-width: 768px) {
    .inner {
        padding: 84px 0;
    }

    .articleInner {
        padding: 64px 0 96px;
    }

    .postTitle {
        font-size: 56px;
    }

    .testimonialsInner {
        padding: 76px 0;
    }

    .testimonialsTitle {
        font-size: 48px;
    }

    .thankYouInner {
        padding: 76px 0;
    }

    .thankYouIntroHeading,
    .thankYouSectionHeading {
        font-size: 50px;
    }

    .thankYouDoctorInner {
        padding: 78px 0 96px;
    }

    .thankYouDoctorGrid {
        grid-template-columns: minmax(300px, 510px) 1fr;
        gap: 42px;
        margin-bottom: 58px;
    }

    .thankYouSubheading {
        font-size: 28px;
    }

    .thankYouDetailGrid {
        margin-bottom: 58px;
    }

    .thankYouFamilyImage {
        margin-bottom: 58px;
    }

    .thankYouCtaItem {
        flex-basis: 49%;
    }

    .thankYouCtaItem:last-child {
        flex-basis: 100%;
    }

    .testimonialBlockWide {
        grid-column: 1 / -1;
    }
}
